module.exports = __webpack_public_path__ + "static/media/laptop.4c3e3199.png";